import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import './WhitelistManagement.css'; // Neue CSS-Datei für das futuristische Styling

const API_BASE = process.env.REACT_APP_API_BASE;

const questions = {
    1: {
        question: 'Was führt dich hierher?',
        good_answer: 'Ich habe viel über den regen Handel in diesem Hafen gehört. Vielleicht finde ich hier eine ehrliche Arbeit als Schiffsmechaniker und kann meine Vergangenheit hinter mir lassen.',
        bad_answer: 'Keine Ahnung, ich guck halt mal rum.'
    },
    2: {
        question: 'Wie hast du dich auf deine Reise vorbereitet?',
        good_answer: 'Ich habe meinen Pass erneuern lassen, die nötigsten Ersparnisse abgehoben und meinem Bruder versprochen, ihm regelmäßig zu schreiben.',
        bad_answer: 'Vorbereitet? Wozu ... ich bin einfach los.'
    },
    3: {
        question: 'Wie verlief der Flug, gab es Probleme ?',
        good_answer: 'Die Flug war ruhig, doch wir gerieten in der Dämmerung in dichten Nebel. Der Pilot meisterte es souverän, aber die Spannung an Board war spürbar.',
        bad_answer: 'War halt ne Bootsfahrt, juckt doch keinen.'
    },
    4: {
        question: 'Mit wie viel Geld bist du hier angekommen?',
        good_answer: 'Etwas über 3 000 Dollar - genug, um die ersten Nächte zu bezahlen und nicht sofort Schulden machen zu müssen.',
        bad_answer: 'Geld brauch ich nicht, ich besorgs mir schon.'
    },
    5: {
        question: 'Kennst du jemanden in der Stadt?',
        good_answer: 'Ein ehemaliger Lehrmeister soll hier eine kleine Werkstatt besitzen; vielleicht kann er mir einen Platz als Geselle geben.',
        bad_answer: 'Ein Kumpel meinte, hier gibts gute Geschäfte.'
    },
    6: {
        question: 'Was willst du dir hier zuerst anschauen oder erleben?',
        good_answer: 'Den Markt am Kai - dort lernt man die Seele einer Stadt am schnellsten kennen.',
        bad_answer: 'Den besten Spot, um schnell Kohle zu scheffeln.'
    },
    7: {
        question: 'Welche Fähigkeiten bringst du mit?',
        good_answer: 'Ich verfüge über drei Jahre Erfahrung als Tischler und habe grundlegende Kenntnisse in Motorenwartung.',
        bad_answer: 'Alles und nichts, ich nehm halt, was kommt.'
    },
    8: {
        question: 'Wie würdest du dich selbst beschreiben?',
        good_answer: 'Ruhig, ausdauernd und loyal. Ich handle erst, wenn ich die Lage ganz verstehe.',
        bad_answer: 'Ich bin der Boss, frag nicht weiter.'
    },
    9: {
        question: 'Was erhoffst du dir von deinem Aufenthalt?',
        good_answer: 'Ein bescheidenes, aber sicheres Leben - vielleicht irgendwann ein eigenes kleines Haus am Stadtrand.',
        bad_answer: 'Ich will hier die Nummer 1 werden, egal wie.'
    },
    10: {
        question: 'Was würdest du tun, wenn du in dieser Stadt ungerecht behandelt wirst?',
        good_answer: 'Zuerst suche ich das Gespräch; wenn das nichts bringt, wende ich mich an die zuständige Behörde, um Ruhe einkehren zu lassen.',
        bad_answer: 'Ich regel das mit meinen Fäusten.'
    }
};

const MIN_REQUIRED_PASS = 8;

const WhitelistManagement = ({ userData, hasPermission }) => {
    const [discordId, setDiscordId] = useState('');
    const [answers, setAnswers] = useState({});
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [correctCount, setCorrectCount] = useState(0);
    const [showAnswers, setShowAnswers] = useState({});

    const canManageWhitelist = hasPermission('manage_support') ||
        userData?.id === process.env.REACT_APP_SUPER_ADMIN_USER ||
        userData?.roles?.includes(process.env.REACT_APP_ADMIN_ROLE_ID);

    const updateCorrectCount = useCallback(() => {
        let count = 0;
        Object.values(answers).forEach(answer => {
            if (answer === 'true') count++;
        });
        setCorrectCount(count);
    }, [answers]);

    useEffect(() => {
        updateCorrectCount();
    }, [updateCorrectCount]);

    const handleAnswerChange = (questionId, value) => {
        setAnswers(prev => ({
            ...prev,
            [questionId]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const answeredCount = Object.keys(answers).filter(key => answers[key] !== undefined).length;
        if (answeredCount < 10) {
            setMessage({ type: 'warning', text: 'Bitte beantworten Sie alle Fragen.' });
            return;
        }

        if (!discordId || !/^\d{17,20}$/.test(discordId)) {
            setMessage({ type: 'warning', text: 'Bitte geben Sie eine gültige Discord-ID ein.' });
            return;
        }

        setLoading(true);
        setMessage(null);

        const isTemporary = correctCount < MIN_REQUIRED_PASS;

        try {
            const token = localStorage.getItem('discord_token');
            const payload = {
                discordId,
                answers,
                temporary: isTemporary
            };
            if (isTemporary) {
                payload.roleId = process.env.REACT_APP_WHITELIST_TEMP_ROLE_ID;
            } else {
                payload.roleId = process.env.REACT_APP_WHITELIST_ADD_ROLE_ID_2;
            }
            const response = await axios.post(`${API_BASE}/api/support-cases/whitelist`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data.success) {
                setMessage({ type: 'success', text: response.data.message });
                setAnswers({});
                setDiscordId('');
            } else {
                setMessage({ type: 'danger', text: response.data.error || 'Fehler beim Speichern.' });
            }
        } catch (error) {
            setMessage({ type: 'danger', text: 'Fehler beim Senden der Daten.' });
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="dashboard-main-futuristic">
                <div className="cyber-loading-container">
                    <div className="cyber-spinner">
                        <div className="cyber-spinner-core"></div>
                        <div className="cyber-spinner-ring"></div>
                        <div className="cyber-spinner-ring-2"></div>
                    </div>
                    <h2 className="cyber-text" data-text="Whitelist Management wird geladen...">
                        Whitelist Management wird geladen...
                    </h2>
                </div>
            </div>
        );
    }

    if (!canManageWhitelist) {
        return (
            <div className="dashboard-main-futuristic">
                <div className="cyber-access-denied">
                    <div className="cyber-shield">
                        <i className="fas fa-shield-alt"></i>
                    </div>
                    <h2 className="cyber-text" data-text="Zugriff verweigert">🚫 Zugriff verweigert</h2>
                    <p className="cyber-subtext">Unzureichende Berechtigungen</p>
                </div>
            </div>
        );
    }

    return (
        <div className="dashboard-main-futuristic">
            <div className="cyber-header">
                <div className="cyber-title">
                    <div className="cyber-icon">
                        <i className="fas fa-user-check"></i>
                    </div>
                    <div>
                        <h2 className="cyber-text" data-text="Whitelist Management">
                            Whitelist Management
                        </h2>
                        <p className="cyber-subtitle">Prüfung und Whitelist-Vergabe für neue Spieler</p>
                    </div>
                </div>
                <div className="cyber-user-info">
                    <div className="cyber-user-badge">
                        <i className="fas fa-user-astronaut"></i>
                        <span>{userData?.nickname || userData?.global_name || 'Unknown'}</span>
                    </div>
                </div>
            </div>

            <div className="cyber-grid">
                <div className="cyber-panel left-panel">
                    <div className="cyber-warning">
                        <div className="cyber-warning-header">
                            <i className="fas fa-exclamation-triangle"></i>
                            <span>Wichtige Hinweise</span>
                        </div>
                        <div className="cyber-warning-content">
                            <p>Führen Sie das Whitelist-Gespräch sorgfältig durch. Mindestens <span className="cyber-highlight">{MIN_REQUIRED_PASS} von 10</span> Fragen müssen richtig beantwortet werden für die volle Whitelist.</p>
                            <p className="cyber-note"><strong>Bei weniger als {MIN_REQUIRED_PASS}/10 wird eine temporäre Rolle für 3 Stunden vergeben.</strong></p>
                            <p className="cyber-note"><i className="fas fa-robot"></i> Team-Support ist erlaubt und sollte keine Fehler machen.</p>
                        </div>
                    </div>

                    <form onSubmit={handleSubmit} className="cyber-form">
                        {message && (
                            <div className={`cyber-alert-banner ${message.type}`}>
                                <div className="cyber-alert-icon">
                                    <i className={`fas ${message.type === 'success' ? 'fa-check-circle' : message.type === 'danger' ? 'fa-exclamation-triangle' : 'fa-info-circle'}`}></i>
                                </div>
                                <div className="cyber-alert-text">{message.text}</div>
                                <div className="cyber-alert-dots"></div>
                            </div>
                        )}

                        <div className="cyber-form-group">
                            <label className="cyber-label">
                                <i className="fab fa-discord"></i>
                                <span>Discord-ID des Users</span>
                                <span className="cyber-required">*</span>
                            </label>
                            <div className="cyber-input-container">
                                <input
                                    type="text"
                                    className="cyber-input"
                                    value={discordId}
                                    onChange={(e) => setDiscordId(e.target.value)}
                                    required
                                    pattern="[0-9]{17,20}"
                                    placeholder="123456789012345678"
                                />
                                <div className="cyber-input-glow"></div>
                            </div>
                            <span className="cyber-hint">17-20 Ziffern eingeben</span>
                        </div>

                        <div className="cyber-score-display">
                            <div className={`cyber-score ${correctCount >= MIN_REQUIRED_PASS ? 'passed' : correctCount > 0 ? 'warning' : 'pending'}`}>
                                <div className="cyber-score-icon">
                                    <i className={`fas ${correctCount >= MIN_REQUIRED_PASS ? 'fa-check' : correctCount > 0 ? 'fa-clock' : 'fa-question'}`}></i>
                                </div>
                                <div className="cyber-score-value">
                                    <span className="cyber-score-number">{correctCount}</span>
                                    <span className="cyber-score-total">/10</span>
                                </div>
                                <div className="cyber-score-label">
                                    {correctCount >= MIN_REQUIRED_PASS ? 'BESTANDEN' : correctCount > 0 ? 'LAUFEND' : 'AUSSTEHEND'}
                                </div>
                            </div>
                        </div>

                        <div className="cyber-submit-section">
                            <button
                                type="submit"
                                className={`cyber-button ${correctCount >= MIN_REQUIRED_PASS ? 'success' : 'warning'}`}
                                disabled={loading || Object.keys(answers).filter(key => answers[key] !== undefined).length < 10 || !discordId}
                            >
                                <div className="cyber-button-content">
                                    {loading ? (
                                        <>
                                            <div className="cyber-spinner-small"></div>
                                            <span>Wird verarbeitet...</span>
                                        </>
                                    ) : correctCount >= MIN_REQUIRED_PASS ? (
                                        <>
                                            <i className="fas fa-check"></i>
                                            <span>Whitelist vergeben ({correctCount}/10)</span>
                                        </>
                                    ) : (
                                        <>
                                            <i className="fas fa-clock"></i>
                                            <span>Temporäre Rolle vergeben ({correctCount}/10)</span>
                                        </>
                                    )}
                                </div>
                                <div className="cyber-button-glow"></div>
                            </button>

                            <div className="cyber-hint-grid">
                                <div className="cyber-hint-item">
                                    <i className="fas fa-robot"></i>
                                    <span>Ergebnis wird automatisch an Discord-Bot gesendet</span>
                                </div>
                                <div className="cyber-hint-item">
                                    <i className="fas fa-clipboard-check"></i>
                                    <span>Alle Fragen müssen beantwortet werden</span>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                <div className="cyber-panel right-panel">
                    <div className="cyber-info-card">
                        <div className="cyber-info-header">
                            <i className="fas fa-info-circle"></i>
                            <span>Whitelist Bewertung</span>
                        </div>
                        <div className="cyber-info-content">
                            <p>Wählen Sie für jede Frage <span className="cyber-highlight">Richtig</span> oder <span className="cyber-highlight">Falsch</span>, um die Whitelist zu protokollieren.</p>
                        </div>
                    </div>

                    <div className="cyber-questions-grid">
                        {Object.entries(questions).map(([id, qa]) => (
                            <div key={id} className={`cyber-question-card ${answers[id] === 'true' ? 'correct' : answers[id] === 'false' ? 'incorrect' : ''}`}>
                                <div className="cyber-question-header">
                                    <div className="cyber-question-id">Q{id}</div>
                                    <h3 className="cyber-question-text">{qa.question}</h3>
                                </div>

                                <div className="cyber-answer-selector">
                                    <label className={`cyber-answer-option ${answers[id] === 'true' ? 'selected correct' : ''}`}>
                                        <input
                                            type="radio"
                                            name={`result_q${id}`}
                                            value="true"
                                            checked={answers[id] === 'true'}
                                            onChange={(e) => handleAnswerChange(id, e.target.value)}
                                            required
                                        />
                                        <div className="cyber-option-content">
                                            <div className="cyber-option-icon">
                                                <i className="fas fa-check"></i>
                                            </div>
                                            <span className="cyber-option-text">Richtig</span>
                                        </div>
                                        <div className="cyber-option-glow"></div>
                                    </label>

                                    <label className={`cyber-answer-option ${answers[id] === 'false' ? 'selected incorrect' : ''}`}>
                                        <input
                                            type="radio"
                                            name={`result_q${id}`}
                                            value="false"
                                            checked={answers[id] === 'false'}
                                            onChange={(e) => handleAnswerChange(id, e.target.value)}
                                        />
                                        <div className="cyber-option-content">
                                            <div className="cyber-option-icon">
                                                <i className="fas fa-times"></i>
                                            </div>
                                            <span className="cyber-option-text">Falsch</span>
                                        </div>
                                        <div className="cyber-option-glow"></div>
                                    </label>
                                </div>

                                <button
                                    className="cyber-toggle-answers"
                                    type="button"
                                    onClick={() => setShowAnswers(prev => ({ ...prev, [id]: !prev[id] }))}
                                >
                                    <i className={`fas ${showAnswers[id] ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                    <span>{showAnswers[id] ? 'Antworten verbergen' : 'Musterantworten anzeigen'}</span>
                                    <div className="cyber-toggle-glow"></div>
                                </button>

                                {showAnswers[id] && (
                                    <div className="cyber-sample-answers">
                                        <div className="cyber-sample-answer correct">
                                            <div className="cyber-sample-header">
                                                <i className="fas fa-check-circle"></i>
                                                <span>Richtige Antwort</span>
                                            </div>
                                            <p className="cyber-sample-text">{qa.good_answer}</p>
                                        </div>
                                        <div className="cyber-sample-answer incorrect">
                                            <div className="cyber-sample-header">
                                                <i className="fas fa-times-circle"></i>
                                                <span>Falsche Antwort</span>
                                            </div>
                                            <p className="cyber-sample-text">{qa.bad_answer}</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhitelistManagement;